module.exports = __webpack_public_path__ + "static/img/7048_phase_function_Paper_Points.c667130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7048_phase_function_Paper_Points.png
// module id = +dTj
// module chunks = 0